




























































import { defineComponent, ref, watch, onMounted } from "@vue/composition-api";

import BaseToken from "@/components/msa/BaseToken.vue";

const { isEqual } = require("lodash");

export default defineComponent({
  components: { BaseToken },
  props: {
    matches: { type: Array },
    codes: { type: Array },
    blocks: { type: Array },
    tokens: { type: Array },
    pages: { type: Array },
    selectedTokens: { type: Array }
  },
  setup(props, context) {
    const parsed = ref([]);

    const update = () => {
      parsed.value = props.blocks.map(block =>
        block.reduce((clusters: any[], token) => {
          clusters.push({
            token: props.tokens[token.index],
            match: props.matches[token.index],
            indices: [token.index]
          });

          return clusters;
        }, [])
      );
    };

    watch(
      [
        () => props.blocks,
        () => props.tokens,
        () => props.codes,
        () => props.selectedTokens
      ],
      () => update()
    );

    const change = (index, value) => {
      props.pages[index].included = value;
      context.emit("page-changed", index);
    };

    onMounted(() => update());

    return { parsed, change };
  }
});
